import activityConfig from "emun.activity/activity.config";
import RegistrationPrompt from "emun.auth/register-retailer.prompt";
import ApprovalPrompt from "emun.auth/retailer-approval";
import ChangeIdPrompt from "emun.customer/customer-change-id";
import ChangeRepPrompt from "emun.customer/customer-change-rep";
import ContactPopup from "emun.customer/customer-contact.popover";
import customerConfig from "emun.customer/customer.config";
import orderConfig from "emun.order/order.config";
import AssignRepPrompt from "emun.retailer/retailer-assign-rep-prompt";
import resolve from "ioc/resolve";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";
import $session from "servicestack/session";
import TagsPrompt from "servicestack/tags/tags-prompt";
import FormSubmissionPrompt from "webforms/formio/formio-submission-prompt";
import modals from "webmodals/modals";
import addressValidatorPrompt from "webutils/address-validator-prompt";

export default class CustomerDashboardController {
  constructor(retailerPrompt) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    $ctrl.$session = $session;
    $ctrl.productImage = $ctrl.$appConfig.productImage.bind($ctrl.$appConfig);
    $ctrl.customerConfig = customerConfig;
    $ctrl.orderConfig = orderConfig;
    $ctrl.activityConfig = activityConfig;
    $ctrl.prompt = retailerPrompt;
    $ctrl.goals = {};
    $ctrl.changeIdPrompt = ChangeIdPrompt;
    $ctrl.changeRepPrompt = ChangeRepPrompt;
    $ctrl.openOrderAmount = 0;
    $ctrl.startDateTY = moment().startOf("year").format("YYYY-MM-DD");
    $ctrl.endDateTY = moment().format("YYYY-MM-DD");
    $ctrl.startDateLY = moment()
      .startOf("year")
      .subtract(12, "months")
      .format("YYYY-MM-DD");
    $ctrl.endDateLY = moment().subtract(12, "months").format("YYYY-MM-DD");
    $ctrl.randomId = (((1 + Math.random()) * 0x10000) | 0)
      .toString(16)
      .substring(1);
    $ctrl.ytdSales = {
      total: 0,
      count: 0,
      avg: 0,
      goal: 0,
    };
    $ctrl.lytdSales = {
      total: 0,
      count: 0,
      avg: 0,
    };
    $ctrl.lySales = {
      total: 0,
      count: 0,
      avg: 0,
    };
    $ctrl.mtdSales = {
      total: 0,
      count: 0,
      avg: 0,
      goal: 0,
    };
    $ctrl.lmtdSales = {
      total: 0,
      count: 0,
      avg: 0,
    };
    $ctrl.dailyInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.yesterdayInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.weekInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.lastweekInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.quarterInvoice = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastquarterInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.ytdInvoice = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastytdInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.lyInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.mtdInvoice = {
      total: 0,
      count: 0,
      percent: 0,
      trend: "neutral",
    };
    $ctrl.lastmtdInvoice = {
      total: 0,
      count: 0,
    };
    $ctrl.statuses = [];
    $ctrl.bus
      .send("QueryRegistrationStatuses.json?OrderBy=SortOrder")
      .then(function (response) {
        $ctrl.statuses = response.data.results;
      });
  }
  getStatus(name) {
    let $ctrl = this;
    var statuses = $ctrl.statuses.filter((s) => s.name == name);
    if (statuses.length > 0) return statuses[0];
  }

  $onInit() {
    const $ctrl = this;
    $ctrl.$pageConfig.goTop();
    $ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
    $ctrl.bus = $ctrl.query.bus;

    $ctrl.ytdSalesQuery = new AutoQuery({
      url:
        "QuerySalesDailyCustomerTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=YTD&GroupBy=CustomerID,CustomerName&customerId=" +
        encodeURIComponent($ctrl.customerId),
      autoLoad: true,
      onLoaded: (args) => $ctrl.onYtdSalesLoaded(args, $ctrl.ytdSales),
    });
    $ctrl.lastytdSalesQuery = new AutoQuery({
      url:
        "QuerySalesDailyCustomerTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=LYTD&GroupBy=CustomerID,CustomerName&customerId=" +
        encodeURIComponent($ctrl.customerId),
      autoLoad: true,
      onLoaded: (args) => $ctrl.onYtdSalesLoaded(args, $ctrl.lytdSales),
    });
    $ctrl.lastySalesQuery = new AutoQuery({
      url:
        "QuerySalesDailyCustomerTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=LastYear&GroupBy=CustomerID,CustomerName&customerId=" +
        encodeURIComponent($ctrl.customerId),
      autoLoad: true,
      onLoaded: (args) => $ctrl.onYtdSalesLoaded(args, $ctrl.lySales),
    });
    $ctrl.mtdSalesQuery = new AutoQuery({
      url:
        "QuerySalesDailyCustomerTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=MTD&GroupBy=CustomerID,CustomerName&customerId=" +
        encodeURIComponent($ctrl.customerId),
      autoLoad: true,
      onLoaded: (args) => $ctrl.onYtdSalesLoaded(args, $ctrl.mtdSales),
    });
    $ctrl.lastmtdSalesQuery = new AutoQuery({
      url:
        "QuerySalesDailyCustomerTotals.json?Fields=CustomerName&Sum=OrderTotal,OrderCount&dateRange=LYMTD&GroupBy=CustomerID,CustomerName&customerId=" +
        encodeURIComponent($ctrl.customerId),
      autoLoad: true,
      onLoaded: (args) => $ctrl.onYtdSalesLoaded(args, $ctrl.lmtdSales),
    });
    $ctrl.propertiesQuery = new AutoQuery({
      url:
        "QueryRetailerProperties.json?RetailerId=" +
        encodeURIComponent($ctrl.customerId),
      autoLoad: false,
      onLoaded: (args) => ($ctrl.customer.additionalProperties = args.results),
    });
    $ctrl.openOrdersQuery = new AutoQuery({
      url:
        "QueryCartsJoin.json?StatusIn=Open,On Hold&GroupBy=Status&Sum=GrandTotal&RetailerId=" +
        encodeURIComponent($ctrl.customerId),
      autoLoad: true,
      pageSize: 1000,
      scrollTop: false,
      onLoaded: function (args) {
        $ctrl.openOrderAmount = 0;
        $ctrl.openOrderAmount = 0;
        args.results.forEach(function (res) {
          switch (res.status) {
            case "Open":
              $ctrl.openOrderAmount = res.sumGrandTotal;
              break;
            case "On Hold":
              $ctrl.onHoldOrderAmount = res.sumGrandTotal;
              break;
            default:
            // code block
          }
        });
      },
    });
    $ctrl.dailyInvoiceQuery = new AutoQuery({
      url:
        "QueryInvoiceYOYTotals.json?Sum=TotalInvoiceToday,TotalInvoiceCountToday,TotalInvoiceYesterday,TotalInvoiceCountYesterday,TotalInvoiceWeekToDate,TotalInvoiceCountWeekToDate,TotalInvoiceQuarterToDate,TotalInvoiceCountQuarterToDate,TotalInvoiceQuarterToDateLastYear,TotalInvoiceCountQuarterToDateLastYear,TotalInvoiceYearToDate,TotalInvoiceCountYearToDate,TotalInvoiceYearToDateLastYear,TotalInvoiceCountYearToDateLastYear,TotalInvoiceLastYear,TotalInvoiceCountLastYear,TotalInvoiceMonthToDate,TotalInvoiceCountMonthToDate,TotalInvoiceMonthToDateLastYear,TotalInvoiceCountMonthToDateLastYear&GroupBy=SalesRepID&CustomerID=" +
        encodeURIComponent($ctrl.customerId),
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          var res = args.first;
          $ctrl.dailyInvoice.total = res.sumTotalInvoiceToday;
          $ctrl.dailyInvoice.count = res.sumTotalInvoiceCountToday;
          $ctrl.yesterdayInvoice.total = res.sumTotalInvoiceYesterday;
          $ctrl.yesterdayInvoice.count = res.sumTotalInvoiceCountYesterday;
          $ctrl.weekInvoice.total = res.sumTotalInvoiceWeekToDate;
          $ctrl.weekInvoice.count = res.sumTotalInvoiceCountWeekToDate;
          $ctrl.quarterInvoice.total += res.sumTotalInvoiceQuarterToDate;
          $ctrl.quarterInvoice.count += res.sumTotalInvoiceCountQuarterToDate;
          $ctrl.lastquarterInvoice.total +=
            res.sumTotalInvoiceQuarterToDateLastYear;
          $ctrl.lastquarterInvoice.count +=
            res.sumTotalInvoiceCountQuarterToDateLastYear;
          var percent = Math.round(
            ($ctrl.quarterInvoice.total / $ctrl.lastquarterInvoice.total) * 100
          );
          if ($ctrl.lastquarterInvoice.total === 0) {
            percent = 100;
          }
          if (percent < 100) {
            $ctrl.quarterInvoice.percent = 100 - percent;
            $ctrl.quarterInvoice.trend = "down";
          } else if (percent > 100) {
            $ctrl.quarterInvoice.percent = percent - 100;
            $ctrl.quarterInvoice.trend = "up";
          } else {
            $ctrl.quarterInvoice.percent = 100;
            $ctrl.quarterInvoice.trend = "neutral";
          }
          $ctrl.ytdInvoice.total += res.sumTotalInvoiceYearToDate;
          $ctrl.ytdInvoice.count += res.sumTotalInvoiceCountYearToDate;
          $ctrl.lastytdInvoice.total += res.sumTotalInvoiceYearToDateLastYear;
          $ctrl.lastytdInvoice.count +=
            res.sumTotalInvoiceCountYearToDateLastYear;
          percent = Math.round(
            ($ctrl.ytdInvoice.total / $ctrl.lastytdInvoice.total) * 100
          );
          if ($ctrl.lastytdInvoice.total === 0) {
            percent = 100;
          }
          if (percent < 100) {
            $ctrl.ytdInvoice.percent = 100 - percent;
            $ctrl.ytdInvoice.trend = "down";
          } else if (percent > 100) {
            $ctrl.ytdInvoice.percent = percent - 100;
            $ctrl.ytdInvoice.trend = "up";
          } else {
            $ctrl.ytdInvoice.percent = 100;
            $ctrl.ytdInvoice.trend = "neutral";
          }
          $ctrl.lyInvoice.total += res.sumTotalInvoiceLastYear;
          $ctrl.lyInvoice.count += res.sumTotalInvoiceCountLastYear;
          console.info("hi there", $ctrl, $ctrl.lyInvoice);
          $ctrl.mtdInvoice.total += res.sumTotalInvoiceMonthToDate;
          $ctrl.mtdInvoice.count += res.sumTotalInvoiceCountMonthToDate;
          $ctrl.lastmtdInvoice.total += res.sumTotalInvoiceMonthToDateLastYear;
          $ctrl.lastmtdInvoice.count +=
            res.sumTotalInvoiceCountMonthToDateLastYear;
          percent = Math.round(
            ($ctrl.mtdInvoice.total / $ctrl.lastmtdInvoice.total) * 100
          );
          if ($ctrl.lastmtdInvoice.total === 0) {
            percent = 100;
          }
          if (percent < 100) {
            $ctrl.mtdInvoice.percent = 100 - percent;
            $ctrl.mtdInvoice.trend = "down";
          } else if (percent > 100) {
            $ctrl.mtdInvoice.percent = percent - 100;
            $ctrl.mtdInvoice.trend = "up";
          } else {
            $ctrl.mtdInvoice.percent = 100;
            $ctrl.mtdInvoice.trend = "neutral";
          }
        }
      },
    });
    //goals
    $ctrl.goalsQuery = new AutoQuery({
      url:
        "QueryRetailerGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth,SalesGoalThisQuarter&GroupBy=vendorID&CustomerID=" +
        encodeURIComponent($ctrl.customerId),
      autoLoad: true,
      pageSize: 1000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.goals.month += Math.round(res.sumSalesGoalThisMonth);
            $ctrl.goals.quarter += Math.round(res.sumSalesGoalThisQuarter);
            $ctrl.goals.year += Math.round(res.sumSalesGoalThisYear);
          });
          $ctrl.goals.monthPercent = Math.round(
            ($ctrl.mtdSales.total / $ctrl.goals.month) * 100
          );
          $ctrl.goals.quarterPercent = Math.round(
            ($ctrl.quarterSales.total / $ctrl.goals.quarter) * 100
          );
          $ctrl.goals.yearPercent = Math.round(
            ($ctrl.ytdSales.total / $ctrl.goals.year) * 100
          );
          $ctrl.ytdSales.goal = $ctrl.goals.year;
          $ctrl.mtdSales.goal = $ctrl.goals.month;
        }
      },
    });
    $ctrl.$on("$retailerApprovalSubmitted", (e, args) => {
      if (
        args.erpCustID &&
        args.erpCustID !== $ctrl.customerId &&
        args.panelPanelColumnsSelectNewStatus &&
        $ctrl.customerConfig.registrationStatusMakeActive.indexOf(
          args.panelPanelColumnsSelectNewStatus
        ) > -1
      ) {
        $ctrl.$state.transitionTo("cust.details", {
          customerId: args.erpCustID,
        });
      } else {
        $ctrl.query.load(true);
      }
    });
    $ctrl.$on("$retailerRequestSubmitted", () => $ctrl.query.load(true));
  }

  getAutoQueryOptions() {
    const $ctrl = this;
    return {
      url: "QueryRetailers.json",
      pageSize: 1,
      orderBy: "CompanyName",
      autoLoad: true,
      append: false,
      criteria: {
        Id: $ctrl.customerId,
        includeSalesData: 1,
      },
      onLoaded: (args) => $ctrl.onRetailerLoaded(args),
    };
  }

  onYtdSalesLoaded(args, field) {
    const $ctrl = this;
    $ctrl.$pageConfig.goTop();
    if (args.total > 0) {
      field.total = Math.round(args.first.sumOrderTotal);
      field.count = args.first.sumOrderCount;
      field.avg = field.total / field.count;
    }
  }

  onRetailerLoaded(args) {
    const $ctrl = this;
    if (args.total === 0) {
      if (
        customerConfig.useOriginalCustomerIdFallabck &&
        !$ctrl.query.criteria.OriginalId
      ) {
        $ctrl.query.criteria.OriginalId = $ctrl.customerId;
        delete $ctrl.query.criteria.Id;
        return $ctrl.query.load();
      }
      return modals.alert("Could not find: " + $ctrl.customerId);
    }
    $ctrl.customer = args.first;
    $ctrl.$pageConfig.goTop();
    $ctrl.customer.location =
      $ctrl.customer.address +
      " " +
      $ctrl.customer.city +
      ", " +
      $ctrl.customer.state +
      " " +
      $ctrl.customer.zip;
    $ctrl.$state.current.customTitle = $ctrl.customer.companyName;
    $ctrl.propertiesQuery.load();
    //if ($ctrl.customer.contact) {
    //	$ctrl.contact = JSON.parse($ctrl.customer.contact);
    //}
    $ctrl.reps = [];
    if ($ctrl.customer.salesReps.length) {
      $ctrl.bus
        .send(`QuerySalesReps.json?Id=${$ctrl.customer.salesReps[0]}`)
        .then(function (res) {
          if (res.data.results.length) $ctrl.reps.push(res.data.results[0]);
          $ctrl.rep = $ctrl.reps[0];
          console.info("$ctrl.reps", $ctrl.rep);
        });
    }
    resolve("NgMap")
      .getMap({ id: "map1" })
      .then((map) => {
        resolve("$timeout")(function () {
          let center = map.getCenter();
          google.maps.event.trigger(map, "resize");
          map.setCenter(center);
        });
      });
    if ($ctrl.autoEdit === "true") {
      $ctrl.autoEdit = "false";
      $ctrl.edit();
    }
    $ctrl.submissionId = $ctrl.customer.tags.AuthorizationForm;
    if ($ctrl.submissionId) {
      $ctrl.bus
        .send(`QueryFormSubmissions/${$ctrl.submissionId}.json`)
        .then(({ data }) => {
          if (data.results.length) {
            $ctrl.submission = {
              label: "register-retailer",
              data: data.results[0].data,
            };
            $ctrl.customer.meta = Object.assign(
              {},
              $ctrl.customer.meta,
              data.results[0].data
            );
          }
        });
    }
  }

  openMap() {
    const $ctrl = this;
    const geoSearchString =
      $ctrl.customer.address +
      " " +
      $ctrl.customer.city +
      ", " +
      $ctrl.customer.state +
      " " +
      $ctrl.customer.zip;
    window.open("http://www.google.com/maps/place/" + geoSearchString);
  }

  editTags(retailer) {
    const $ctrl = this;
    return TagsPrompt.open({
      title: retailer.id + " - " + retailer.companyName + " Tags...",
      tags: retailer.tags,
      principalId: retailer.id,
      shard: "Retailer",
    }).then(() => $ctrl.query.load(true));
  }
  changeID() {
    const $ctrl = this;
    return $ctrl.changeIdPrompt
      .open({ retailer: this.customer })
      .then(function (obj) {
        $ctrl.$state.transitionTo("customer.dashboard", {
          customerId: obj.updated,
        });
      });
  }
  changeRep() {
    const $ctrl = this;
    return $ctrl.changeRepPrompt
      .open({ RetailerIds: this.customer.id })
      .then(function (obj) {
        $ctrl.query.load(true);
      });
  }

  edit() {
    const $ctrl = this;
    return $ctrl.prompt.edit(this.customer).then(() => {
      window.location.reload();
    });
  }
  load() {
    const $ctrl = this;

    return $ctrl.query.load.apply($ctrl.query, arguments);
  }
  fireResizeMap() {
    const $ctrl = this;
    $ctrl.$broadcast("resizeMap");
  }
  contactPopup(customer, contactId) {
    const $ctrl = this;
    ContactPopup.open({ customer: customer });
  }
  startOrder() {
    const $ctrl = this;
    $ctrl.$cart.createPrompt({
      retailer: $ctrl.customer,
      paymentTermsId: $ctrl.customer.paymentTerms,
      status: "Cart",
    });
  }
  approvalPrompt() {
    const $ctrl = this;
    return ApprovalPrompt.open({
      title:
        $ctrl.customer.id +
        " - " +
        $ctrl.customer.companyName +
        " Required Approval...",
      retailer: $ctrl.customer,
    }).then(function () {
      //$ctrl.query.load(true);
    });
  }
  assignRep() {
    const $ctrl = this;
    return AssignRepPrompt.open({
      title:
        $ctrl.customer.id +
        " - " +
        $ctrl.customer.companyName +
        " Assign Rep...",
      retailer: $ctrl.customer,
    }).then(function () {
      $ctrl.query.load(true);
    });
  }

  registrationPrompt() {
    const $ctrl = this;
    return RegistrationPrompt({
      title:
        $ctrl.customer.id +
        " - " +
        $ctrl.customer.companyName +
        " Registration...",
      retailer: $ctrl.customer,
    }).then(() => $ctrl.query.load(true));
  }
  formSubmissionPrompt() {
    const $ctrl = this;
    return FormSubmissionPrompt({
      formioId: "DesignerSignUp",
      submissionId: $ctrl.submissionId,
    }).then(() => $ctrl.query.load(true));
  }
  approve(retailer) {
    let $ctrl = this;
    let url = `ApproveRetailer.json`;
    return modals
      .confirm("Approve this retailer request?", "Retailer Request")
      .result.then(() => {
        return $ctrl.bus.send(url, retailer).then((res) => $ctrl.load());
      });
  }
  complete(retailer) {
    let $ctrl = this;
    let url = `CompleteRetailer.json`;
    return modals
      .confirm("Complete this retailer request?", "Retailer Request")
      .result.then(() => {
        return $ctrl.bus.send(url, retailer).then((res) => $ctrl.load());
      });
  }
  decline(retailer) {
    let $ctrl = this;
    let url = `DeclineRetailer.json`;
    return modals
      .confirm("Decline this retailer request?", "Retailer Request")
      .result.then(() => {
        return $ctrl.bus.send(url, retailer).then((res) => $ctrl.load());
      });
  }
  toggleKeyAccount() {
    let $ctrl = this;
    $ctrl.bus.send("UpdateRetailer", $ctrl.customer);
  }
  validateAddress(customer) {
    const $ctrl = this;
    addressValidatorPrompt
      .open({ model: customer, key: customer.id })
      .then(function (address) {
        if (address.valid && address.selected) {
          customer.companyName = address.selected.companyName;
          customer.address = address.selected.address;
          customer.address2 = address.selected.address2;
          customer.city = address.selected.city;
          customer.state = address.selected.state;
          customer.zip = address.selected.zip;
          customer.tags["latitude"] = address.selected.latitude;
          customer.tags["longitude"] = address.selected.longitude;
          $ctrl.query.bus.send("UpdateRetailer", customer).then(function () {
            $ctrl.query.load(true);
          });
        }
      });
  }
  getRandomNumber() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
}
